const state = {
    previousPage: "",
    previousPageStatus: false,
    previousPageData :[]
}
const getters = {
    get_previousPage: state => {
        let previousPage = {
            pageName: state.previousPage,
            pageStatus: state.previousPageStatus,
            pageData : state.previousPageData
        }
        return previousPage
    },
}
const actions = {
    set_previousPage(context, string) {
        context.commit('SET_PREVIOUSPAGE', string);
    },
    set_previousPageData(context, obj) {
        context.commit('SET_PREVIOUSPAGEDATA', obj);
    },
    clear_previousPageData(context){
        context.commit('CLEAR_PREVIOUSPAGEDATA');
    },
    clear_previousPage(context) {
        context.commit('CLEAR_PREVIOUSPAGE');
    }
}
const mutations = {
    SET_PREVIOUSPAGE(state, string) {
        state.previousPage = string;
        state.previousPageStatus = true;
    },
    SET_PREVIOUSPAGEDATA(state, array) {
        state.previousPageData = array;
    },
    CLEAR_PREVIOUSPAGEDATA(state){
        state.previousPageData = [];
    },
    CLEAR_PREVIOUSPAGE(state) {
        state.previousPage = "";
        state.previousPageStatus = false;
        console.log('clear');
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/previousPage.js